@let current = scan();
@let artikel = current.artikelMenge.artikel;
<div
  class="flex flex-col border rounded w-full p-1.5 bg-surface mb-3"
  data-testid="scan-correction-header"
>
  <span class="flex items-center gap-2 flex-wrap">
    <span class="ds-caption color-light">{{ artikel.nummer }}</span>
    @if (current.kzerfassung === 'R') {
      <span
        class="flex flex-row gap-1 items-center bg-warning rounded-full px-2 text-warning-contrast ds-caption w-fit"
        data-testid="scan-correction-retoure"
      >
        <soft-icon name="fa-regular fa-turn-left" class="fa-xs"></soft-icon>
        {{ '#KOMMISSIONIERUNG.DIALOGS.ERFASSTE_MENGEN.RETOURE' | translate }}
      </span>
    } @else if (current.kzerfassung === 'Z') {
      <span
        class="flex flex-row gap-1 items-center bg-success rounded-full px-2 text-success-contrast ds-caption w-fit"
        data-testid="scan-correction-zusatz"
      >
        <soft-icon name="fa-regular fa-square-plus" class="fa-xs"></soft-icon>
        {{ '#KOMMISSIONIERUNG.DIALOGS.ERFASSTE_MENGEN.ZUSATZPOSITION' | translate }}
      </span>
    }
  </span>
  <span class="ds-body-1-semibold">{{ artikel.artbez1 }}</span>
  @if (current.artikelMenge.vermerk; as vermerk) {
    <span class="ds-caption color-light" data-testid="scan-correction-vermerk">
      {{ '#KOMMISSIONIERUNG.DIALOGS.ERFASSTE_MENGEN.VERMERK' | translate }}: {{ vermerk }}
    </span>
  }
  @if (current.lagerplatz?.lagerplatz; as lagerplatz) {
    <span class="ds-caption color-light" data-testid="scan-correction-lagerplatz">
      {{ '#KOMMISSIONIERUNG.DIALOGS.SCAN_KORREKTUR.LAGERPLATZ' | translate }}: {{ lagerplatz }}
    </span>
  }
  <soft-batch-info [charge]="current.artikelMenge.charge" [mhd]="current.artikelMenge.mhd" />
  @if (current.scanPalette?.sscc; as sscc) {
    <span class="ds-caption color-light" data-testid="scan-correction-palette">
      {{ '#KOMMISSIONIERUNG.DIALOGS.SCAN_KORREKTUR.PALETTE' | translate }}: {{ sscc }}
    </span>
  }
  <span class="ds-body-2 mt-1" data-testid="scan-correction-captured">
    {{ '#KOMMISSIONIERUNG.DIALOGS.SCAN_KORREKTUR.ERFASST' | translate }}:
    {{ current.artikelMenge.menge }} {{ current.artikelMenge.einheit.arteh }}
  </span>
</div>

@if (isPallet()) {
  <span class="ds-body-2 color-light" data-testid="scan-correction-pallet-hint">
    {{ '#KOMMISSIONIERUNG.DIALOGS.SCAN_KORREKTUR.GANZE_PALETTE' | translate }}
  </span>
} @else {
  <span class="soft-overline">
    {{ '#KOMMISSIONIERUNG.DIALOGS.SCAN_KORREKTUR.NEUE_MENGE' | translate }}
  </span>
  <soft-ds-quantity-input
    size="lg"
    [value]="quantity()"
    [min]="0"
    [max]="current.artikelMenge.menge"
    [unit]="current.artikelMenge.einheit.arteh"
    [float]="true"
    (valueChange)="quantity.set($event ?? 0)"
    data-testid="scan-correction-quantity"
  />
  <span class="ds-caption color-light mt-1">
    {{ '#KOMMISSIONIERUNG.DIALOGS.SCAN_KORREKTUR.SUBTITLE' | translate }}
  </span>
}

<ng-template #bottomTemplate>
  <div class="flex w-full gap-2 mt-3 mb-1">
    <soft-ds-button
      variant="destructive"
      mode="iconOnly"
      [aria-label]="'#KOMMISSIONIERUNG.DIALOGS.SCAN_KORREKTUR.ENTFERNEN' | translate"
      (click)="remove()"
      data-testid="scan-correction-remove"
    >
      <ng-template softSlot="leading">
        <soft-ds-icon name="fa-regular fa-trash" />
      </ng-template>
    </soft-ds-button>
    <soft-ds-button
      class="flex-1"
      variant="primary"
      (click)="apply()"
      data-testid="scan-correction-apply"
    >
      {{
        (mode() === 'confirm'
          ? '#KOMMISSIONIERUNG.DIALOGS.SCAN_KORREKTUR.BESTAETIGEN'
          : '#KOMMISSIONIERUNG.DIALOGS.SCAN_KORREKTUR.UEBERNEHMEN'
        ) | translate
      }}
    </soft-ds-button>
  </div>
</ng-template>
